/*
 * judge-me-labels.js
 *
 * Judge.me ships "Write a review" on the PDP widget. CSS text-transform
 * cannot title-case only the last word (capitalize turns "a" into "A").
 * Patch the primary CTA to the exact label: "Write a Review".
 */
(function () {
  var WRITE_REVIEW_LABEL = 'Write a Review';

  function formatWriteReviewButton(root) {
    root.querySelectorAll('.jm-action-buttons .jm-button--primary').forEach(function (btn) {
      var textEl = btn.querySelector('.jm-text') || btn;
      var current = textEl.textContent.replace(/\s+/g, ' ').trim();
      if (/^write\s+a\s+review$/i.test(current) && current !== WRITE_REVIEW_LABEL) {
        textEl.textContent = WRITE_REVIEW_LABEL;
      }
    });
  }

  function init() {
    var roots = document.querySelectorAll(
      '.shopify-section--apps, .jdgm-review-widget, #judgeme_product_reviews'
    );
    if (!roots.length) return;

    var run = function () {
      roots.forEach(formatWriteReviewButton);
    };

    run();

    roots.forEach(function (root) {
      new MutationObserver(run).observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
